import { SourceEnum } from '@/bundles/Pipelines/types';

export const SourceLabels = {
  [SourceEnum.cold_call]: 'Cold Call',
  [SourceEnum.sign_call]: 'Sign Call',
  [SourceEnum.inbound_broker_referral]: 'Inbound Broker Referral',
  [SourceEnum.outbound_client_referral]: 'Outbound Client Referral',
  [SourceEnum.inbound_web]: 'Inbound Web',
  [SourceEnum.past_client]: 'Repeat Client',
  [SourceEnum.direct_marketing]: 'Direct Marketing',
  [SourceEnum.client_referral]: 'Client Referral',
};
